import React from 'react';
import { useSelector } from 'react-redux';
import If from './If';
import Price from "./Price";
import ActionButton from "./ActionButton";
import { Plural, useLingui } from '@lingui/react/macro';
import { navigate } from '../utils/navigationUtils';

function PlannerContainer(props) {
    const authentication = useSelector(state => state.authentication);
    const cart = useSelector(state => state.cart);
    const cruises = useSelector(state => state.cruises ? state.cruises.cruiseDetails : null);

    const {t} = useLingui();

    return (
        <If test={authentication.isAuthenticated && cruises && cruises.length > 0}>
            <div className={`bg-grey-lightest shadow print-hidden py-2 ${props.sticky ? "sticky top-0 z-10" : ""}`}>
                <div className="container mx-auto sm:flex sm:justify-end">
                    <div className="shadow w-full sm:w-auto text-primary-dark p-2 sm:p-4 bg-white flex justify-between items-center">
                        <div>
                            <div>
                                <Price
                                    largePreText={true}
                                    preText={t({id: "total_price"})}
                                    price={cart.totalPrice}
                                    currencySymbol={cart.currencySymbol}
                                />
                            </div>
                            <div className="mt-1">
                                <span className="font-bold">
                                    {cart.nrExcursions}
                                </span>
                                <span>
                                    <Plural
                                        id="x_items_in_planner"
                                        value={cart.nrExcursions}
                                        _1=" item in your planner"
                                        other=" items in your planner"
                                    />
                                </span>
                            </div>
                        </div>
                        <div className="sm:ml-4">
                            <ActionButton
                                onClick={() => {navigate(t({id: '/checkout'}))}}
                                disabled={cart.nrExcursions === 0}
                                classes="px-6"
                                buttonText={t({id: "continue_items_in_planner"})}/>
                        </div>
                    </div>
                </div>
            </div>
        </If>
    );
}

export default PlannerContainer;